// @flow

import React from 'react';
import './alternative-titles.scss';
import { getList } from '../../utilities/workinfo';

type Props = {
  hideNavBar: Function,
  showNavBar: Function,
  searchDetails: any,
};

class AlternativeTitles extends React.Component<Props> {
  componentDidMount() {
    const { hideNavBar } = this.props;
    hideNavBar();
  }

  componentWillUnmount() {
    const { showNavBar } = this.props;
    showNavBar();
  }

  titleCase(str) {
    return str.toLowerCase()
      .replace(/((^|[\s(])\w)/g, v => v.toUpperCase());
  }

  goBackToPreviousPage() {
    window.history.go(-1);
  }

  render() {
    const { searchDetails } = this.props;
    return (
      <section className="main-content alternative-title d-flex flex-column">
        <header>
          <div className="prs-icon-holder">
            <button type="button" onClick={this.goBackToPreviousPage} className="prs-icon prs-icon-cross" />
          </div>
          <h1>
            <span className="prs-icon prs-icon-alt-titles" />
            Alternative title
          </h1>
        </header>
        <div className="alternative-title--body flex-grow-1">
          {getList(searchDetails.titles, 'Alternative Title').map(v => (
            <p key={v}>{this.titleCase(v)}</p>
          ))}
        </div>
        <footer>
          <button type="button" onClick={this.goBackToPreviousPage}>Close</button>
        </footer>
      </section>
    );
  }
}

export default AlternativeTitles;
